import { ProductWarehouseStockItem } from "@api/productApi";
import EXPIRY_TYPE_OPTIONS from "@constant/ExpiryType";

/** 依庫存實際存在的效期種類，回傳可選的效期種類選項 */
export default function getAvailableExpiryTypeOptions(stockItems: ProductWarehouseStockItem[]) {
  const availableValues = new Set(stockItems.map((item) => item.isExpiring ?? false));
  return EXPIRY_TYPE_OPTIONS.filter((option) => availableValues.has(option.value));
}
